module.exports = __webpack_public_path__ + "img/edit-light-blue.91ad810b.svg";